<% for (var layerId in layers) { %>
    <li class="vector-map-settings-popup__choice">
        <input type="radio" data-map-settings-tiles-control
                name="map_settings_tiles"
                id="map-settings-<%= layers[layerId].tilejson.name %>"
                value="<%= layers[layerId].tilejson.name %>"
                <% if(selected === layers[layerId].tilejson.name) { %>checked<% } %>>
        <label for="map-settings-<%= layers[layerId].tilejson.name %>"><%= layers[layerId].tilejson.description %></label>
    </li>
<% } %>

